module.exports = __webpack_public_path__ + "img/IMG_6904.067cadbd.webp";